module.exports = __webpack_public_path__ + "img/chat.c9c60351.svg";